import React, { useMemo } from 'react';

import {
  Flex, HStack, Spinner, Text,
} from '@chakra-ui/react';
import { useMutation } from 'react-query';
import { useParams } from 'react-router-dom';

import { reviewTraining, unassignTraining } from 'api/training';
import { Icon, StatusBadge } from 'components';
import { TrainingStatus } from 'enums/status';
import { UserTypes } from 'enums/types';

export default function UserItem({
  index, style, data, refetch,
}) {
  const { id } = useParams<GeneralRoute>();

  const item = useMemo(() => ({
    ...data[index].trainings?.find((training) => training.id === Number(id)),
    ...data[index],
  }), [index, data, id]);
  const { mutate, isLoading } = useMutation(
    (status: TrainingStatus) => reviewTraining({ id, userId: item.id, data: { status } }),
    {
      onSuccess: () => refetch(),
    });

  const { mutate: unassign } = useMutation(
    (userId: number) => unassignTraining({ id, userId }),
    {
      onSuccess: () => refetch(),
    },
  );
  return (
    <Flex
      p={2}
      cursor="pointer"
      style={style}>
      <Flex
        borderRadius={8}
        px={6}
        py={4}
        width="100%"
        height="56px"
        bg="white.default">
        <Flex
          alignItems="center"
          width="100%"
          justifyContent="space-between">
          <HStack>
            <Text
              color="gray.600"
              variant="mediumBold">
              {item.name}
            </Text>
            <Text variant="xSmallRegular">
              {item.type === UserTypes.Driver ? item.type : item.role?.name ?? 'N/A'}
            </Text>
          </HStack>
          <HStack>
            <Text variant="xSmallRegular">
              {item.email}
            </Text>
            <StatusBadge status={item.trainingStatus} />
            <HStack
              cursor="pointer"
              onClick={() => unassign(item.id)}>
              <Icon
                name="trash-alt"
                color="gray.600"
              />
              <Text variant="xSmallSemiBold">Remover</Text>
            </HStack>
            {isLoading && <Spinner />}
            <HStack
              hidden={item.trainingStatus !== TrainingStatus.InReview}
              spacing={4}>
              <HStack onClick={() => {
                mutate(TrainingStatus.Finished);
              }}>
                <Icon
                  name="check"
                  color="system.success.default"
                />
                <Text variant="xSmallSemiBold">Aprovar</Text>
              </HStack>
              <HStack onClick={() => {
                mutate(TrainingStatus.Pending);
              }}>
                <Icon
                  name="times"
                  color="system.error.default"
                />
                <Text variant="xSmallSemiBold">Reprovar</Text>
              </HStack>
            </HStack>
          </HStack>
        </Flex>
      </Flex>
    </Flex>
  );
}
